// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/UserService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { IdentityUserDtoSchema, IdentityUserIdWithCredentialsDtoSchema, IdentityUserWithCredentialsDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import type { IdentityUserCollectionDtoSchema } from "../Messages/Collections_pb";
import { file_Messages_Collections } from "../Messages/Collections_pb";
import type { UuidDtoSchema, UuidWithDeletedItemSelectionDtoSchema } from "../Messages/Common_pb";
import { file_Messages_Common } from "../Messages/Common_pb";
import type { IdentityUserDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import type { IdentityUserFiltersDtoSchema } from "../Messages/Filters_pb";
import { file_Messages_Filters } from "../Messages/Filters_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/UserService.proto.
 */
export const file_Services_UserService: GenFile = /*@__PURE__*/
  fileDesc("ChpTZXJ2aWNlcy9Vc2VyU2VydmljZS5wcm90bzLSCQoLVXNlclNlcnZpY2US1AEKB0dldFVzZXISPi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmNvbW1vbi5VdWlkV2l0aERlbGV0ZWRJdGVtU2VsZWN0aW9uRHRvGjgudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5JZGVudGl0eVVzZXJEZXRhaWxlZER0byJPoNrNDwKC0+STAkRaFjoBKiIRL2FwaS91c2VyL2dldFVzZXISKi9hcGkvdXNlci9nZXRVc2VyL3tpZC5oaWdoXzY0fS97aWQubG93XzY0fRKlAQoIR2V0VXNlcnMSNi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmZpbHRlcnMuSWRlbnRpdHlVc2VyRmlsdGVyc0R0bxo9LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuY29sbGVjdGlvbnMuSWRlbnRpdHlVc2VyQ29sbGVjdGlvbkR0byIioNrNDwKC0+STAhc6ASoiEi9hcGkvdXNlci9nZXRVc2VycxKqAQoKQ3JlYXRlVXNlchI8LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuYmFzaWMuSWRlbnRpdHlVc2VyV2l0aENyZWRlbnRpYWxzRHRvGjgudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5JZGVudGl0eVVzZXJEZXRhaWxlZER0byIkoNrNDwCC0+STAhk6ASoiFC9hcGkvdXNlci9jcmVhdGVVc2VyEs8BCgpVcGRhdGVVc2VyEi0udGltZV90cmFja2luZy5tZXNzYWdlcy5iYXNpYy5JZGVudGl0eVVzZXJEdG8aOC50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmRldGFpbGVkLklkZW50aXR5VXNlckRldGFpbGVkRHRvIlig2s0PAILT5JMCTToBKloZOgEqIhQvYXBpL3VzZXIvdXBkYXRlVXNlchotL2FwaS91c2VyL3VwZGF0ZVVzZXIve2lkLmhpZ2hfNjR9L3tpZC5sb3dfNjR9EoICChJVcGRhdGVVc2VyUGFzc3dvcmQSPi50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLklkZW50aXR5VXNlcklkV2l0aENyZWRlbnRpYWxzRHRvGjgudGltZV90cmFja2luZy5tZXNzYWdlcy5kZXRhaWxlZC5JZGVudGl0eVVzZXJEZXRhaWxlZER0byJyoNrNDwKC0+STAmc6ASpaIToBKiIcL2FwaS91c2VyL3VwZGF0ZVVzZXJQYXNzd29yZBo/L2FwaS91c2VyL3VwZGF0ZVVzZXJQYXNzd29yZC97dXNlcl9pZC5oaWdoXzY0fS97dXNlcl9pZC5sb3dfNjR9Er8BCgpEZWxldGVVc2VyEiYudGltZV90cmFja2luZy5tZXNzYWdlcy5jb21tb24uVXVpZER0bxo4LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZGV0YWlsZWQuSWRlbnRpdHlVc2VyRGV0YWlsZWREdG8iT6DazQ8CgtPkkwJEWhk6ASoiFC9hcGkvdXNlci9kZWxldGVVc2VyKicvYXBpL3VzZXIvZGVsZXRlVXNlci97aGlnaF82NH0ve2xvd182NH1CJKoCIU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5TZXJ2aWNlc2IGcHJvdG8z", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Messages_Collections, file_Messages_Common, file_Messages_Detailed, file_Messages_Filters, file_Options_MethodOptions]);

/**
 * CRUD operations for identity users.
 *
 * @generated from service UserService
 */
export const UserService: GenService<{
  /**
   * Fetch a user specified by their id.
   * Policy: Users can only fetch their own details.
   *
   * @generated from rpc UserService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof UuidWithDeletedItemSelectionDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
  /**
   * Fetch users according to filters.
   * Policy: Users must specify only their user id in the ids filter.
   *
   * @generated from rpc UserService.GetUsers
   */
  getUsers: {
    methodKind: "unary";
    input: typeof IdentityUserFiltersDtoSchema;
    output: typeof IdentityUserCollectionDtoSchema;
  },
  /**
   * Create a new user.
   *
   * @generated from rpc UserService.CreateUser
   */
  createUser: {
    methodKind: "unary";
    input: typeof IdentityUserWithCredentialsDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
  /**
   * Modify user properties.
   *
   * @generated from rpc UserService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof IdentityUserDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
  /**
   * Change the password of the user with the specified id.
   * Policy: Users can only update their own password.
   *
   * @generated from rpc UserService.UpdateUserPassword
   */
  updateUserPassword: {
    methodKind: "unary";
    input: typeof IdentityUserIdWithCredentialsDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
  /**
   * Delete the user with the given id.
   *
   * @generated from rpc UserService.DeleteUser
   */
  deleteUser: {
    methodKind: "unary";
    input: typeof UuidDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_UserService, 0);

